$(".classfortabs4").click(function(){
  var classforsub = $(this).attr("forloopindex");
   $(this).toggleClass("active");
    $(".showthis" + classforsub ).toggleClass("active");
  });
  
  $('.targetsizechart').on('click',function (e) {
    
    var target = this.hash,
        $target = $(target);
  
    $('html, body').stop().animate({
      'scrollTop': $target.offset().top-70
    }, 900, 'swing', function () {
      window.location.hash = target;
    });
   setTimeout(function() {
    $("#sizecharttarget").trigger("click");
    }, 950);
  });
  
  
  $(document).ready(function() {
    // Add to Cart button click event
    $('.add-to-cart-btn').on('click', function(event) {
      event.preventDefault();
      var productId = $(this).data('product-id');
  
      // Make the AJAX request to add the product to the cart
      $.ajax({
        type: 'POST',
        url: '/cart/add.js', // Shopify's AJAX API endpoint to add a product to the cart
        data: { quantity: 1, id: productId },
        dataType: 'json',
        success: function(data) {
          // Show a notification or update the cart preview
          showCartNotification(data);
        },
        error: function(error) {
          console.error(error);
        }
      });
    });
  
    // Function to show a notification or update the cart preview
    function showCartNotification(data) {
      // You can customize this function to display a notification or update the cart preview on the page.
      // For example, you can use a toast notification library or update the cart count in the header.
    }
  });
  $(window).scroll(function() {    
      var scroll = $(window).scrollTop();
  
      if (scroll >= 80) {
          $("body").addClass("scollup-class");
      } else {
          $("body").removeClass("scollup-class");
      }
  });
  
  const links = document.querySelectorAll('a.product-item__aspect-ratio:has(.product-item__secondary-image)');
  for (var link of links) {
      let touchStartX = 0;
      let touchStartY = 0;
      let touchTimeout;
      const linkHref = link.href;
      link.addEventListener('touchstart', (event) => {
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
          touchTimeout = setTimeout(() => {
              clearTimeout(touchTimeout);
          }, 500);
      });
      link.addEventListener('touchmove', (event) => {
          clearTimeout(touchTimeout);
      });
      link.addEventListener('touchend', (event) => {
          clearTimeout(touchTimeout);
          const deltaX = Math.abs(event.changedTouches[0].clientX - touchStartX);
          const deltaY = Math.abs(event.changedTouches[0].clientY - touchStartY);
  
          if (deltaX < 10 && deltaY < 10) {
        
              window.location.href = linkHref;
          }
      });
  }
  
  // Quick Add to Cart functionality
  function refreshCart() {
    fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((cartContent) => {
        document.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
            },
          })
        );
      });
  }
  
  async function addProductToCart(vid) {
    let formData = {
      items: [
        {
          id: vid,
          quantity: 1,
        },
      ],
    };
    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        refreshCart();
        // Open the Focal theme cart drawer by setting its open property
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.open = true;
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
  
  // Click-based size picker functionality
  document.addEventListener("click", function (event) {
    // Handle product-item-atc button click
    const atcButton = event.target.closest(".product-item-atc");
    if (atcButton) {
      event.preventDefault();
      event.stopPropagation();
      
      const vid = atcButton.getAttribute("data-vid");
      const cartSizePicker = atcButton.closest(".cart-size-picker");
      
      if (cartSizePicker) {
        const cardSizePicker = cartSizePicker.querySelector(".card-size-picker");
        
        if (cardSizePicker) {
          // Remove active class from all other cart-size-picker elements
          document.querySelectorAll(".cart-size-picker.active").forEach(function(activePicker) {
            if (activePicker !== cartSizePicker) {
              activePicker.classList.remove("active");
            }
          });
          
          // Toggle active class on the clicked cart-size-picker
          cartSizePicker.classList.toggle("active");
        } else {
          // No size picker, add to cart directly
          addProductToCart(vid);
        }
      }
      return;
    }
    
    // Handle close button click
    const closeButton = event.target.closest(".card-size-picker-close");
    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();
      const cartSizePicker = closeButton.closest(".cart-size-picker");
      if (cartSizePicker) {
        cartSizePicker.classList.remove("active");
      }
      return;
    }
    
    // Handle variant selection in size picker
    const swatch = event.target.closest(".swatch");
    if (swatch && swatch.closest(".card-size-picker")) {
      event.preventDefault();
      event.stopPropagation();
      
      const value = swatch.getAttribute("data-value");
      const productContainer = swatch.closest(".product-container");
      
      if (productContainer) {
        // Update active swatch
        swatch.closest(".swatch-list").querySelectorAll(".swatch").forEach(s => s.classList.remove("active"));
        swatch.classList.add("active");
        
        // Find the variant ID for the selected value
        const variants = JSON.parse(productContainer.getAttribute("data-variants"));
        let selectedVariant = null;
        
        for (let variant of variants) {
          if (variant.option1 === value || variant.option2 === value || variant.option3 === value) {
            selectedVariant = variant;
            break;
          }
        }
        
        if (selectedVariant && selectedVariant.available) {
          // Update the data-vid attribute on the ATC button
          const cartSizePicker = swatch.closest(".cart-size-picker");
          if (cartSizePicker) {
            const atcButton = cartSizePicker.querySelector(".product-item-atc");
            if (atcButton) {
              atcButton.setAttribute("data-vid", selectedVariant.id);
            }
            
            // Add to cart
            addProductToCart(selectedVariant.id);
            
            // Close the size picker by removing active from cart-size-picker
            cartSizePicker.classList.remove("active");
          }
        }
      }
      return;
    }
    
    // Close size picker when clicking outside (but not on product-item-atc or inside card-size-picker)
    const clickedOnAtcButton = event.target.closest(".product-item-atc");
    const clickedInsideCardSizePicker = event.target.closest(".card-size-picker");
    
    if (!clickedOnAtcButton && !clickedInsideCardSizePicker) {
      document.querySelectorAll(".cart-size-picker.active").forEach(function(activePicker) {
        activePicker.classList.remove("active");
      });
    }
  });
  


/* custom variant picker  */
function getSiblingWithClass(element, className) {
  if (element.classList.contains(className)) {
    return element;
  }
  let sibling = element.nextElementSibling;
  while (sibling) {
    if (sibling.classList.contains(className)) {
      return sibling;
    }
    sibling = sibling.nextElementSibling;
  }
  sibling = element.previousElementSibling;
  while (sibling) {
    if (sibling.classList.contains(className)) {
      return sibling;
    }
    sibling = sibling.previousElementSibling;
  }
  return null;
}
document.addEventListener("click", function (event) {
  var swatch = event.target.closest(".swatch");
  if (swatch) {
    const container = swatch.closest(".product-container");
    const product_block = container.closest(".product-container-container");
    if (container) {
      var variants = JSON.parse(container.getAttribute("data-variants"));
      var product_url = container.getAttribute("data-url");
      const swatchContainer = swatch.closest(".swatch-container");
      const swatchList = Array.from(swatchContainer.querySelectorAll(".swatch"));
      swatchList.forEach((s) => s.classList.remove("active"));
      swatch.classList.add("active");
      var selectedOptions = [];
      var optionContainers = container.querySelectorAll(".swatch-container");
      optionContainers.forEach(function (optionContainer) {
        var activeSwatch = optionContainer.querySelector(".swatch.active");
        if (activeSwatch) {
          selectedOptions.push(activeSwatch.getAttribute("data-value"));
        } else {
          selectedOptions.push(null);
        }
      });
      var selectedVariant = findVariant(variants, selectedOptions);
      if (selectedVariant) {
        container.setAttribute("data-variant-selected", selectedVariant.id);
        updateSoldOutStates(container, variants, selectedOptions);
        if (swatch.classList.contains("other_opt") && !swatch.classList.contains("soldout_variant")) {
          addProductToCart(selectedVariant.id);
        }
        if (swatch.classList.contains("other_opt") && swatch.classList.contains("soldout_variant")) {
          product_block.querySelector(".BIS_trigger").click();
        }
      }
    }
  }
});
function findVariant(variants, selectedOptions) {
  return variants.find(
    (variant) => variant.option1 == selectedOptions[0] && variant.option2 == selectedOptions[1] && variant.option3 == selectedOptions[2]
  );
}
function updateSoldOutStates(container, variants, selectedOptions) {
  const optionContainers = container.querySelectorAll(".swatch-container");
  optionContainers.forEach(function (optionContainer, index) {
    const swatches = optionContainer.querySelectorAll(".swatch");
    swatches.forEach(function (swatch) {
      const value = swatch.getAttribute("data-value");
      const currentSelectedOptions = [...selectedOptions];
      currentSelectedOptions[index] = value;
      const matchingVariant = findVariant(variants, currentSelectedOptions);
      if (matchingVariant && !matchingVariant.available) {
        swatch.classList.add("soldout_variant");
      } else {
        swatch.classList.remove("soldout_variant");
      }
    });
  });
}
function refreshCart() {
  fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
    const cartContent = await response2.json();

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent,
        },
      })
    );
  });
}
async function addProductToCart(vid) {
  let formData = {
    items: [
      {
        id: vid,
        quantity: 1,
      },
    ],
  };
  const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      refreshCart();
      // Open the Focal theme cart drawer by setting its open property
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        cartDrawer.open = true;
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
/* END:Custom variant picker */

const cpSliderScheduled = new WeakSet();
const CP_SLIDER_SECOND_EXCLUDED = "#mini-cart, #shopify-section-mini-cart, .shopify-section--mini-cart";

function cpAbSecondSlideOn() {
  return document.documentElement.classList.contains("ab-card-second-slide");
}

function cpSliderWantsSecond(sliderInner) {
  if (!cpAbSecondSlideOn()) return false;
  if (!sliderInner || sliderInner.children.length < 2) return false;
  if (sliderInner.closest(CP_SLIDER_SECOND_EXCLUDED)) return false;
  return true;
}

function cpSliderLeadImage(sliderInner) {
  const slide = cpSliderWantsSecond(sliderInner) ? sliderInner.children[1] : sliderInner.children[0];
  return slide ? slide.querySelector("img") : sliderInner.querySelector(".cp-product-slider-slide img");
}

function cpSliderIsMeasurable(slider, sliderInner) {
  if (slider.getBoundingClientRect().width < 1) return false;

  const leadImage = cpSliderLeadImage(sliderInner);
  if (!leadImage) return true;
  if (leadImage.getBoundingClientRect().height >= 1) return true;
  return leadImage.complete && leadImage.naturalWidth > 0;
}

function cpSliderRelayout(sliderInner, attempt) {
  const flickityInstance = sliderInner.flickityInstance;
  if (!flickityInstance || !sliderInner.isConnected) return;

  flickityInstance.resize();

  const viewport = sliderInner.querySelector(".flickity-viewport");
  if (viewport && viewport.getBoundingClientRect().height >= 1) return;

  const nextAttempt = (attempt || 0) + 1;
  if (nextAttempt <= 6) {
    window.setTimeout(() => cpSliderRelayout(sliderInner, nextAttempt), 120 * nextAttempt);
  }
}

function cpInstallSecondSlidePatch() {
  const Flickity = window.Flickity;
  if (!Flickity || !Flickity.prototype || Flickity.prototype.__cpSecondInstant) return;
  if (!document.documentElement.classList.contains("ab-card-second-slide")) return;

  const original = Flickity.prototype.select;
  Flickity.prototype.select = function (index, isWrap, isInstant) {
    const el = this.element;
    // Image loads call select() again and animate. An animated re-select
    // travels across photo 1 before it settles on photo 2.
    if (el && el._cpSecond && Number(index) === this.selectedIndex) {
      isInstant = true;
    }
    return original.call(this, index, isWrap, isInstant);
  };
  Flickity.prototype.__cpSecondInstant = true;
}

function initCpProductSlider(slider, sliderInner) {
  if (sliderInner.flickityInstance || typeof window.Flickity !== "function") return;

  cpInstallSecondSlidePatch();

  let config = {};
  try {
    config = JSON.parse(sliderInner.getAttribute("data-config") || "{}");
  } catch (error) {
    config = {};
  }

  // Flickity remeasures after each image loads instead of keeping the
  // 0px height it captured while the file was still pending.
  config.imagesLoaded = true;

  if (cpSliderWantsSecond(sliderInner)) {
    config.initialIndex = 1;
    sliderInner._cpSecond = true;
  }

  try {
    sliderInner.flickityInstance = new Flickity(sliderInner, config);
  } catch (error) {
    return;
  }

  const flickityInstance = sliderInner.flickityInstance;
  if (config.initialIndex === 1 && flickityInstance && flickityInstance.selectedIndex !== 1) {
    flickityInstance.select(1, false, true);
  }

  requestAnimationFrame(() => cpSliderRelayout(sliderInner));
}

function scheduleCpProductSlider(slider) {
  const sliderInner = slider.querySelector(".cp-product-slider-inner");
  if (!sliderInner || sliderInner.flickityInstance || sliderInner.children.length < 2) return;
  if (cpSliderScheduled.has(slider)) return;
  cpSliderScheduled.add(slider);

  const tryInit = () => {
    if (!slider.isConnected || sliderInner.flickityInstance) return;
    if (slider.getBoundingClientRect().width < 1) return;

    const leadImage = cpSliderLeadImage(sliderInner);
    if (leadImage && leadImage.loading === "lazy") {
      leadImage.loading = "eager";
    }

    if (!cpSliderIsMeasurable(slider, sliderInner)) {
      if (leadImage && !leadImage._cpInitBound) {
        leadImage._cpInitBound = true;
        leadImage.addEventListener("load", tryInit, { once: true });
        leadImage.addEventListener("error", tryInit, { once: true });
      }
      return;
    }

    initCpProductSlider(slider, sliderInner);
  };

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        tryInit();
      },
      { rootMargin: "400px 0px" }
    );
    observer.observe(slider);
  } else {
    tryInit();
  }

  if ("ResizeObserver" in window) {
    const resizeObserver = new ResizeObserver(() => {
      if (sliderInner.flickityInstance) {
        const width = slider.getBoundingClientRect().width;
        if (width < 1 || Math.abs(width - (slider._cpLastWidth || 0)) < 1) return;
        slider._cpLastWidth = width;
        cpSliderRelayout(sliderInner);
        return;
      }

      tryInit();
    });
    resizeObserver.observe(slider);
  }
}

function cpJumpReadySliders() {
  if (!cpAbSecondSlideOn()) return;

  document.querySelectorAll(".cp-product-slider-inner.flickity-enabled").forEach((sliderInner) => {
    if (!cpSliderWantsSecond(sliderInner)) return;

    const secondImage = sliderInner.querySelector(".flickity-slider .cp-product-slider-slide:nth-child(2) img");
    if (secondImage && secondImage.loading === "lazy") secondImage.loading = "eager";

    const flickityInstance = sliderInner.flickityInstance;
    sliderInner._cpSecond = true;
    if (
      flickityInstance &&
      flickityInstance.slides &&
      flickityInstance.slides.length > 1 &&
      flickityInstance.selectedIndex !== 1
    ) {
      flickityInstance.select(1, false, true);
    }
  });
}

function cpProductSlider() {
  if (typeof window.Flickity !== "function") return;
  cpInstallSecondSlidePatch();
  document.querySelectorAll("[data-slider]").forEach(scheduleCpProductSlider);
  cpJumpReadySliders();
}

document.addEventListener("DOMContentLoaded", function () {
  cpProductSlider();
  window.addEventListener("load", cpProductSlider);

  if (!cpAbSecondSlideOn()) {
    const classObserver = new MutationObserver(() => {
      if (!cpAbSecondSlideOn()) return;
      classObserver.disconnect();
      cpProductSlider();
    });
    classObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  const sliderObserver = new MutationObserver((mutations) => {
    const hasNewSlider = mutations.some((mutation) =>
      Array.from(mutation.addedNodes || []).some((node) => {
        if (!(node instanceof HTMLElement)) return false;
        return node.matches("[data-slider]") || node.querySelector?.("[data-slider]");
      })
    );

    if (hasNewSlider) {
      cpProductSlider();
    }
  });

  sliderObserver.observe(document.body, { childList: true, subtree: true });
});